import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

export const useSettingsDialogStyles = makeStyles({
  dialogSurface: {
    maxWidth: '900px',
    width: '90vw',
    maxHeight: '80vh',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  dialogSurfaceMobile: {
    width: '100vw',
    maxWidth: '100vw',
    height: '100dvh',
    maxHeight: '100dvh',
    ...shorthands.borderRadius('0'),
    ...shorthands.margin('0'),
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
    overflow: 'hidden',
  },
  dialogBody: {
    display: 'flex',
    flexDirection: 'row',
    ...shorthands.gap(tokens.spacingHorizontalL),
    minHeight: '400px',
    flex: 1,
    minWidth: 0,
  },
  dialogBodyMobile: {
    flexDirection: 'column',
    ...shorthands.gap(tokens.spacingVerticalM),
    minHeight: 0,
  },
  tabListVertical: {
    flexShrink: 0,
    width: '180px',
    ...shorthands.borderRight(tokens.strokeWidthThin, 'solid', tokens.colorNeutralStroke2),
    paddingRight: tokens.spacingHorizontalM,
  },
  tabListMobile: {
    width: '100%',
    ...shorthands.borderRight('none'),
    ...shorthands.borderBottom(tokens.strokeWidthThin, 'solid', tokens.colorNeutralStroke2),
    paddingRight: '0',
    paddingBottom: tokens.spacingVerticalS,
    overflowX: 'auto',
    overflowY: 'hidden',
    flexWrap: 'nowrap',
    columnGap: tokens.spacingHorizontalXS,
  },
  mobileTabsBar: {
    display: 'flex',
    alignItems: 'center',
    ...shorthands.gap(tokens.spacingHorizontalXS),
    width: '100%',
    overflowX: 'auto',
    overflowY: 'hidden',
    ...shorthands.padding(0, 0, tokens.spacingVerticalS, 0),
    ...shorthands.borderBottom(tokens.strokeWidthThin, 'solid', tokens.colorNeutralStroke2),
  },
  mobileTabButton: {
    minHeight: '40px',
    whiteSpace: 'nowrap',
    flexShrink: 0,
  },
  tabContent: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap(tokens.spacingVerticalS),
    paddingTop: tokens.spacingVerticalS,
    minHeight: 0,
    flexGrow: 1,
    overflowY: 'auto',
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap(tokens.spacingVerticalM),
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    ...shorthands.gap(tokens.spacingHorizontalS),
    ...shorthands.borderBottom(tokens.strokeWidthThin, 'solid', tokens.colorNeutralStroke2),
    paddingBottom: tokens.spacingVerticalS,
    marginBottom: tokens.spacingVerticalS,
  },
  severityRow: {
    display: 'grid',
    gridTemplateColumns: '120px 1fr 1fr',
    alignItems: 'center',
    ...shorthands.gap(tokens.spacingHorizontalM),
    ...shorthands.padding(tokens.spacingVerticalS, '0'),
  },
  severityRowHeader: {
    display: 'grid',
    gridTemplateColumns: '120px 1fr 1fr',
    alignItems: 'center',
    ...shorthands.gap(tokens.spacingHorizontalM),
    ...shorthands.padding(tokens.spacingVerticalXS, '0'),
    color: tokens.colorNeutralForeground3,
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightSemibold,
  },
  soundRow: {
    display: 'grid',
    gridTemplateColumns: '120px auto 1fr auto',
    alignItems: 'center',
    ...shorthands.gap(tokens.spacingHorizontalM),
    ...shorthands.padding(tokens.spacingVerticalS, '0'),
  },
  soundRowHeader: {
    display: 'grid',
    gridTemplateColumns: '120px auto 1fr auto',
    alignItems: 'center',
    ...shorthands.gap(tokens.spacingHorizontalM),
    ...shorthands.padding(tokens.spacingVerticalXS, '0'),
    color: tokens.colorNeutralForeground3,
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightSemibold,
  },
  inputField: {
    width: '100%',
    minWidth: '80px',
  },
  mobileField: {
    minHeight: '44px',
  },
  fileInput: {
    display: 'none',
  },
  fileName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: tokens.colorNeutralForeground2,
    fontSize: tokens.fontSizeBase200,
  },
  noFile: {
    color: tokens.colorNeutralForeground3,
    fontStyle: 'italic',
    fontSize: tokens.fontSizeBase200,
  },
  uploadButton: {
    flexShrink: 0,
  },
  testButton: {
    flexShrink: 0,
  },
  mobileIconButton: {
    minWidth: '40px',
    minHeight: '40px',
  },
  groupRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 150px auto',
    alignItems: 'center',
    ...shorthands.gap(tokens.spacingHorizontalM),
    ...shorthands.padding(tokens.spacingVerticalS, '0'),
  },
  groupRowHeader: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 150px auto',
    alignItems: 'center',
    ...shorthands.gap(tokens.spacingHorizontalM),
    ...shorthands.padding(tokens.spacingVerticalXS, '0'),
    color: tokens.colorNeutralForeground3,
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightSemibold,
  },
  headerWithInfo: {
    display: 'inline-flex',
    alignItems: 'center',
    ...shorthands.gap(tokens.spacingHorizontalXS),
  },
  infoIconWrap: {
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'help',
  },
  infoIcon: {
    color: tokens.colorNeutralForeground3,
    fontSize: tokens.fontSizeBase300,
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    ...shorthands.padding(tokens.spacingVerticalXXL, '0'),
    color: tokens.colorNeutralForeground3,
    textAlign: 'center',
  },
  mobileCard: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap(tokens.spacingVerticalS),
    ...shorthands.padding(tokens.spacingVerticalM, tokens.spacingHorizontalM),
    ...shorthands.border(tokens.strokeWidthThin, 'solid', tokens.colorNeutralStroke2),
    ...shorthands.borderRadius(tokens.borderRadiusLarge),
    backgroundColor: tokens.colorNeutralBackground1,
  },
  mobileCardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    ...shorthands.gap(tokens.spacingHorizontalS),
  },
  mobileCardRow: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap(tokens.spacingVerticalXS),
  },
  mobileLabel: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground3,
    fontWeight: tokens.fontWeightSemibold,
  },
  mobileActionsRow: {
    display: 'flex',
    alignItems: 'center',
    ...shorthands.gap(tokens.spacingHorizontalXS),
    flexWrap: 'wrap',
  },
  dialogActionsMobile: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    ...shorthands.gap(tokens.spacingVerticalS),
  },
  saveStatusWrap: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flex: 1,
  },
  dialogActions: {
    flexShrink: 0,
  },
});
